export default __webpack_public_path__ + "static/media/720.3849cdf2.png";